import { loadLeadOpp, loadLeadOpps } from '../common/api';

const leadopps = {
    name: 'leadopps',
    state: { 
        current: {
            details: {},
            members: []
        },
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.loid
            }
        },
        cdcInsert: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.loid]: { 
                        ...state.byId[payload.loid],
                        ...payload.cdc 
                    }
                }
            }
        },
        cdcInsertMember: ( state, payload ) => {
            const [ loid, oid ] = payload.loid.split( '#' );
            let member = ( state.byId[loid] && state.byId[loid].relationships ) ? state.byId[loid].relationships : []; 
            member.push( payload.cdc );

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [loid]: { 
                        ...state.byId[loid],
                        relationships: member
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.loid]: {
                        ...state.byId[payload.loid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcModifyMember: ( state, payload ) => {
            const [ loid, oid ] = payload.loid.split( '#' );
            const member = ( state.byId[loid] && state.byId[loid].relationships ) ? state.byId[loid].relationships : [];
            const mod = member.map( m => {
                if ( m.lorid === payload.loid ) {
                    return {
                        ...m,
                        ...payload.cdc
                    }
                }
                return m;
            } );

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [loid]: {
                        ...state.byId[loid],
                        relationships: mod
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.loid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        cdcRemoveMember: ( state, payload ) => {
            const [ loid, oid ] = payload.loid.split( '#' );
            let member = state.byId[loid].relationships.filter( f => f.cid !== oid );

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [loid]: { 
                        ...state.byId[loid],
                        relationships: member
                    }
                }
            }
        },
        loadedLeadOpps: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        },
        loadedLeadOpp: ( state, payload ) => {
            return {
                ...state,
                current: {
                    ...state.current,
                    details: payload.details,
                    members: payload.members
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadLeadOpp( { aid, uid, loid } ) {
            const lo = await loadLeadOpp( aid, uid, loid );
            lo.members.forEach( m => {
                m['id'] = m.cid;
            } );
            dispatch.leadopps.loadedLeadOpp( lo );
        },
        async loadLeadOpps( { aid, uid } ) {
            const list = await loadLeadOpps( aid, uid );
            let byId = {};
            list.forEach( lo => byId[lo.loid] = lo );
            dispatch.leadopps.loadedLeadOpps( byId );
        },
        insert( { loid, cdc } ) {
            const member = loid.match( '#' );
            if ( member ) {
                dispatch.leadopps.cdcInsertMember( { loid, cdc } );
            } else {
                dispatch.leadopps.cdcInsert( { loid, cdc } );
            }
        },
        modify( { loid, cdc } ) {
            const member = loid.match( '#' );
            if ( member ) {
                dispatch.leadopps.cdcModifyMember( { loid, cdc } );
            } else {
                dispatch.leadopps.cdcModify( { loid, cdc } );
            }
        },
        remove( { loid } ) {
            const member = loid.match( '#' );
            if ( member ) {
                dispatch.leadopps.cdcRemoveMember( { loid } );
            } else {
                dispatch.leadopps.cdcRemove( { loid } );
            }
        },
        setCurrent( { loid } ) {
            dispatch.leadopps.setCurrentId( { loid } );
        }
    } )
}

export default leadopps;